export enum TipoRelatorio {
  APURACAO_POR_RECEBIMENTO = 'APURACAO_POR_RECEBIMENTO',
  APURACAO_POR_VENDA = 'APURACAO_POR_VENDA',
}
